import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React from "react";

import { testLocator } from "@/lib/helpers/test-locator";

import { AptihealthIcon } from "../../Icons/AptihealthIcon";
import { CameraIcon } from "../../Icons/CameraIcon";
import { CardHeading } from "../../UI/Headings";
import { DocumentIcon } from "../../Icons/DocumentIcon";
import { EnvelopeIcon } from "../../Icons/EnvelopeIcon";
import { LockIcon } from "../../Icons/LockIcon";
import { SettingsIcon } from "../../Icons/SettingsIcon";
import { TourIcon } from "../../Icons/TourIcon";

import SettingsList from "./SettingsList";

const Settings = (props) => {
  const { baseRoute } = props;

  const showChangePassword = props.profile && !props.profile.idp;

  return (
    <div data-public="true">
      <CardHeading className="py-md-4 mb-0 mx-md-3 d-none d-md-block fs-18" text="Settings" />
      <div className="Settings__HorizontalLine d-none d-md-block"></div>
      <div className="px-3 px-lg-4">
        <Link to={baseRoute + "/tutorial"}>
          <SettingsList iconComponent={TourIcon} text="View Tutorials" />
        </Link>
        {/* <SettingsList text='Notifications' imgName='Notification' /> */}
        {showChangePassword && (
          <Link to={baseRoute + "/change-password"}>
            <SettingsList
              iconComponent={LockIcon}
              text="Change Password"
              {...testLocator("settingsChangePasswordLink")}
            />
          </Link>
        )}
        <a href="https://www.aptihealth.com/privacy" rel="noreferrer" target="_blank">
          <SettingsList iconComponent={DocumentIcon} text="Privacy Policy" />
        </a>
        <a href="mailto:support@aptihealth.com?subject=Web Support Request" target="_top">
          <SettingsList iconComponent={EnvelopeIcon} text="Email Support" />
        </a>
        <Link to={baseRoute + "/system-check"}>
          <SettingsList iconComponent={SettingsIcon} text="System Check" />
        </Link>
        <Link to={baseRoute + "/av-check"}>
          <SettingsList iconComponent={CameraIcon} text="Test Audio & Video" />
        </Link>
        <a href="https://www.aptihealth.com/about/" rel="noreferrer" target="_blank">
          <SettingsList iconComponent={AptihealthIcon} text="About aptihealth" />
        </a>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps, null)(Settings);
